import type { ADataGridFilter } from "@atiautomacao/ati-ui-library";
import { Storage } from "../../../../../Utils/StorageUtils";

export const ALARM_ADVANCED_FILTERS_KEY = 'alarm_advanced_filters';

export const getInitialFilterState = (): FilterState => {
  const stored = Storage.local.get(ALARM_ADVANCED_FILTERS_KEY, null);
  if (!stored || !Array.isArray(stored)) {
    return { equipmentTypeIds: [], severityName: [], situationNames: [] };
  }
  const state: FilterState = { equipmentTypeIds: [], severityName: [], situationNames: [] };
  (stored as ADataGridFilter[]).forEach((f) => {
    const values = f.value ? String(f.value).split('~').filter(Boolean) : [];
    if (f.name === 'equipmentTypeId') state.equipmentTypeIds = values;
    else if (f.name === 'severityName') state.severityName = values;
    else if (f.name === 'situation') state.situationNames = values;
  });
  return state;
};

/**
 * Tipos e Interfaces compartilhadas entre
 * SideBarFilterAlarms e DesktopFilterAlarms
 */

export interface FilterState {
  equipmentTypeIds: string[];
  severityName: string[];
  situationNames: string[];
}

export interface EquipmentType {
  id: number;
  name: string;
  displayName: string;
  sortPriority: number;
}


export interface AlarmSeverity {
  id: number;
  name: string;
  displayName: string;
  sortPriority: number;
}

/**
 * Opções de Situação (estáticas, não vêm da API)
 */
export interface SituationOption {
  name: "has_alarm_sound" | "active" | "equipment_no_communication" | "not_acknowledged";
  displayName: string;
}

/**
 * Props compartilhadas entre filtros
 */
export interface FilterComponentProps {
  onApplyFilters: (filters: Array<any>, count: number) => void;
  hasClearFilters: boolean;
  initialFilters?: ADataGridFilter[];
}

export interface SideBarFilterState {
  loading: boolean;
  saving: boolean;
  errorMessage: string | undefined;
  successMessage: string | undefined;
  equipments: EquipmentType[];
  severities: AlarmSeverity[];
}

/**
 * Contantes para Situações
 */
export const SITUATION_OPTIONS: SituationOption[] = [
  { name: "has_alarm_sound", displayName: "Sonoro" },
  { name: "active", displayName: "Ativo" },
  { name: "equipment_no_communication", displayName: "Sem comunicação" },
  { name: "not_acknowledged", displayName: "Não reconhecido" },
];

